import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import FormControl from '@mui/material/FormControl';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import FormLabel from '@mui/material/FormLabel';
import Select from '@mui/material/Select';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import CircularProgress from '@mui/material/CircularProgress';
import DialogTitle from '@mui/material/DialogTitle';
import Backdrop from '@mui/material/Backdrop';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { DataGrid } from '@mui/x-data-grid';
import { useState } from 'react';
import { Document, Page, Text, StyleSheet, View, pdf, Font  } from '@react-pdf/renderer';
import apiClient from '../ApiClient/ApiClient';

// ------------------- 表格設定（維持原本） -------------------
const columns2 = [
  {
    field: '日期',
    headerName: '日期',
    width: 110,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (p) => (p.value ? dayjs(p.value).format('YYYY/MM/DD') : '')
  },
  { field: '單號', headerName: '單號', width: 100, editable: true, headerAlign: 'center', align: 'center' },
  { field: '批號', headerName: '批號', type: 'number', width: 110, editable: true, headerAlign: 'center', align: 'center' },
  { field: '廠商', headerName: '廠商', type: 'number', width: 80, editable: true, headerAlign: 'center', align: 'center' },
  {
    field: '需求日',
    headerName: '需求日',
    type: 'number',
    width: 110,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (p) => (p.value ? dayjs(p.value).format('YYYY/MM/DD') : '')
  },
  { field: '類別', headerName: '類別', type: 'number', width: 110, editable: true, headerAlign: 'center', align: 'center' },
  { field: '圖號', headerName: '圖號', type: 'number', width: 110, editable: true, headerAlign: 'center' },
  { field: '物品名', headerName: '物品名', type: 'number', width: 240, editable: true, headerAlign: 'center' },
  { field: '庫存量', headerName: '庫存量', type: 'number', width: 100, editable: true },
  { field: '數量', headerName: '數量', type: 'number', width: 80, editable: true },
  { field: '訂單號碼', headerName: '訂單號碼', width: 110, editable: true },
  { field: '單位', headerName: '單位', width: 110, editable: true },
  { field: '流水號', headerName: '流水號', width: 110, editable: true },
  { field: 'id', headerName: 'ID', width: 90 },
];

export default function LaunchProduct() {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const [hasMakeProcess, setHasMakeProcess] = useState(false);
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const day = String(currentDate.getDate()).padStart(2, '0');
  const formattedDate = `${year}-${month}-${day}`;
  const [value, setValue] = useState(dayjs(formattedDate));
  const [billNums, setBillNums] = useState([]);
  const [request, setRequest] = useState({
    way: 'piNum',
    num: '',
    model: '',
    qty: 0,
    date: '',
    isHand: 0,
    user: sessionStorage.getItem('userName'),
  });
  const [row1, setRow1] = useState([]);
  const [row2, setRow2] = useState([]);
  const [cmdNoStart, setCmdNoStart] = useState('');
  const [cmdNoEnd, setCmdNoEnd] = useState('');

  // ---------- 新增：busy 管理 ----------
  const [busyKey, setBusyKey] = useState(null); // null | 'step1' | 'step2' | 'step3' | 'step4' | 'bom' | 'print'
  const busy = !!busyKey;
  const isBusy = (k) => busyKey === k;
  const withBusy = async (key, fn) => {
    if (busy) return;         // 防止連點
    setBusyKey(key);
    try {
      await fn();
    } finally {
      setBusyKey(null);
    }
  };

  const columns = [
    {
      field: '操作',
      headerName: '操作',
      width: 80,
      renderCell: (params) => (
        <IconButton
          onClick={() => handleDeleteRow(params.id)}
          color="primary"
          aria-label="delete"
          disabled={busy}         // 忙碌中不可刪
        >
          <DeleteIcon />
        </IconButton>
      ),
    },
    { field: '客戶', headerName: '客戶', width: 100, editable: true, headeralign: 'center' },
    { field: '訂單號碼', headerName: '訂單號碼', width: 110, editable: true, headeralign: 'center', align: 'center' },
    { field: '物品名', headerName: '物品名', type: 'number', width: 110, editable: true, headeralign: 'center', align: 'center' },
    { field: '圖號', headerName: '圖號', type: 'number', width: 110, editable: true, headeralign: 'center', align: 'center' },
    { field: '項次', headerName: '項次', type: 'number', width: 60, editable: true, headeralign: 'center' },
    { field: '訂單數量', headerName: '訂單數量', type: 'number', width: 100, editable: true, headeralign: 'center' },
    { field: '發動數量', headerName: '發動數量', type: 'number', width: 100, editable: true, headeralign: 'center' },
    {
      field: '未發動數量',
      headerName: '未發動數量',
      type: 'number',
      width: 100,
      editable: false,
      valueGetter: (params) => {
        const totalQty = params.row.訂單數量 ?? 0;
        const activatedQty = params.row.發動數量 ?? 0;
        return totalQty - activatedQty;
      },
    },
    { field: '本次發動數', headerName: '本次發動數', type: 'number', width: 110, editable: true },
    { field: '庫存量', headerName: '庫存量', type: 'number', width: 110, editable: true },
    { field: '生產量', headerName: '生產量', type: 'number', width: 110, editable: true },
    { field: '材料圖號', headerName: '材料圖號', type: 'number', width: 110, editable: true },
    { field: 'id', headerName: 'ID', width: 90 },
  ];

  const handleInputChange = (value, fieldName) => {
    setRequest((prevRequest) => ({
      ...prevRequest,
      [fieldName]: value.target ? value.target.value : value,
    }));
  };

  const [open, setOpen] = useState(false);
  const [printItems, setPrintItems] = useState([]);
  const [bomOpen, setBomOpen] = useState(false);
  const [pdfData, setPdfData] = useState([]);

  const handleDeleteRow = (id) => setRow1((prevRows) => prevRows.filter((row) => row.id !== id));
  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleStep1Submit = async () => {
    await withBusy('step1', async () => {
      const requestFormat = {
        way: request.way,
        num: request.num,
        model: request.model,
        qty: parseInt(request.qty, 10),
        date: value.format('YYYY-MM-DD'),
        isHand: request.isHand,
        user: sessionStorage.getItem('userName'),
      };
      try {
        const response = await apiClient.get(
          `/MatCard/GetStep1OrderList?way=${requestFormat.way}&num=${requestFormat.num}&isHand=${requestFormat.isHand}`
        );
        if (response.status === 200) {
          setRow1(response.data);
          // ★ 這裡從回傳資料取出「機種」，塞回輸入框用的 request.model
        if (response.data && response.data.length > 0) {
          const first = response.data[0]; // 先用第一筆
          setRequest(prev => ({
            ...prev,
            // 如果你不想覆蓋使用者自己打的，就用 prev.model || first.機種
            model: first.機種 ?? ''
          }));
        }
          alert('成功');
        }
      } catch (error) {
        console.error(error);
        alert('找無資料 或是欄位輸入有錯');
      }
    });
  };

  const handleStep2Submit = async () => {
    await withBusy('step2', async () => {
      const row1Data = row1.map(({ id, 本次發動數 }) => ({
        Id: id,
        本次發動數,
      }));
      const requestFormat = {
        way: request.way,
        num: request.num,
        model: request.model,
        qty: parseInt(request.qty, 10),
        date: value.format('YYYY-MM-DD'),
        isHand: request.isHand,
        user: sessionStorage.getItem('userName'),
        Row1Data: row1Data,
      };
      try {
        const response = await apiClient.post(`/MatCard/GetStep2UpdateOrderList`, requestFormat);
        if (response.status === 200) {
          setRow1(response.data);
          if (response.data.length > 0) {
            setRequest((prev) => ({ ...prev, model: response.data[0].機種 ?? '' }));
          }
          alert('成功');
        }
      } catch (error) {
        console.error(error);
        alert('找無資料 或是欄位輸入有錯');
      }
    });
  };

  const handleStep3Submit = async () => {
    await withBusy('step3', async () => {
      const row1Data = row1.map(({ id, 本次發動數 }) => ({
        Id: id,
        本次發動數,
      }));
      const requestFormat = {
        Way: request.way,
        Num: request.num,
        Model: request.model,
        Qty: parseInt(request.qty, 10),
        Date: value.format('YYYY-MM-DD'),
        IsHand: request.isHand,
        User: sessionStorage.getItem('userName'),
        Row1Data: row1Data,
      };
  
      // 只針對這次呼叫關閉快取
      const noCacheConfig = {
        headers: {
          // 要求中繼節點不要快取請求/回應
          'Cache-Control': 'no-store, no-cache, must-revalidate, max-age=0',
          'Pragma': 'no-cache',
          'Expires': '0',
        },
        // cache buster：確保 URL 每次都不同（即使是 POST，一些代理仍可能誤快取）
        params: { _t: Date.now() },
      };
  
      try {
        const response = await apiClient.post(`/MatCard/GetStep3MakeData`, requestFormat, noCacheConfig);
        if (response.status === 200) {
          setRow2(response.data.datas);
          setHasMakeProcess(response.data.hasMakeProcess);
          alert('成功');
        }
      } catch (error) {
        console.error(error);
        alert('找無資料 或是欄位輸入有錯');
      }
    });
  };
  

  const handleStep4Submit = async () => {
    setOpen(false);
  
    await withBusy('step4', async () => {
      try {
        const payload = {
          user: sessionStorage.getItem('userName'),
          row1Ids: row1.map((r) => r.id),
          row2Ids: row2.map((r) => r.id),
          // Dayjs 物件轉成字串，後台的 DateTime? 會自動解析
          date: value ? value.format('YYYY-MM-DD') : null,
        };
  
        const response = await apiClient.post(`/MatCard/SaveDataAlertStep4`, payload);
  
        if (response.status === 200) {
          // 後台現在直接回傳 { list, billNums }
          console.log('Step4 response.data =', response.data);
          const { list, billNums, billNoStart, billNoEnd } = response.data;
  
          setRow2(list || []);          // 產生採購最新資料（多半會被清空）
          setBillNums(billNums || []);  // 這次產生的製令單號清單

          setCmdNoStart(billNoStart ?? '');
          setCmdNoEnd(billNoEnd ?? '');
  
          alert('存入資料成功');
        }
      } catch (error) {
        console.error(error);
        alert('找無資料 或是欄位輸入有錯');
      }
    });
  };
  

  // 只送上方 DataGrid (row1) 的資料，後端回 PDF，前端新視窗開啟
// 只送上方 DataGrid (row1) 的資料，格式同 handleStep3Submit，後端回 PDF，前端新視窗開啟
const downloadExcel = async () => {
  await withBusy('bom', async () => {
    try {
      // 1) Row1Data：跟 step3 一樣，只帶 Id、本次發動數
      const row1Data = row1.map(({ id, 本次發動數 }) => ({
        Id: id,
        本次發動數,
      }));

      // 2) Body：鍵名與 step3 完全一致
      const body = {
        Way: request.way,
        Num: request.num,
        Model: request.model,
        Qty: parseInt(request.qty, 10),
        Date: value.format('YYYY-MM-DD'),
        IsHand: request.isHand,
        User: sessionStorage.getItem('userName'),
        Row1Data: row1Data,
      };

      // 建議使用新的 API 路徑（後端收這個 body，產 PDF）
      const targetUrl = `/MatCard/GenerateBomPdfFromRows`;

      const resp = await apiClient.post(targetUrl, body, {
        responseType: 'blob', // 接收 PDF
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-store, no-cache, must-revalidate, max-age=0',
          Pragma: 'no-cache',
          Expires: '0',
        },
        params: { _t: Date.now() }, // 防快取
      });

      if (resp.status === 200) {
        const blob = new Blob([resp.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        // 3) 另開視窗預覽
        const win = window.open(url, '_blank');
        if (!win || win.closed || typeof win.closed === 'undefined') {
          const a = document.createElement('a');
          a.href = url;
          a.target = '_blank';
          a.rel = 'noopener';
          document.body.appendChild(a);
          a.click();
          a.remove();
        }
      } else {
        alert('無法產生 PDF');
      }
    } catch (error) {
      console.error('BOM PDF 產生失敗：', error);
      alert('下載/產生 BOM 發生錯誤');
    }
  });
};


const downloadMakeCmdExcel = async () => {
  await withBusy('print', async () => {
    try {
      if (!cmdNoStart || !cmdNoEnd) {
        alert('尚未取得起始/結束製令，請先完成「2.存入資料」');
        return;
      }

      // num 你說要帶 piNum，這裡依你的 request.way 判斷：若 way=piNum 就用 request.num
      // 如果你永遠都是批號，就直接 const piNum = request.num;
      const piNum = request.num;

      const resp = await apiClient.get(
        `/MatCard/GetPrintMakeCmd`,
        {
          params: {
            start: cmdNoStart,
            end: cmdNoEnd,
            uuser: sessionStorage.getItem('userName'),
            num: piNum,
          },
          responseType: 'blob',
          headers: {
            'Cache-Control': 'no-store, no-cache, must-revalidate, max-age=0',
            Pragma: 'no-cache',
            Expires: '0',
          },
        }
      );

      // 這裡假設後端回 PDF；如果你回的是 Excel，就把 type / 副檔名換掉
      const blob = new Blob([resp.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `製令_${cmdNoStart}-${cmdNoEnd}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('製令列印失敗：', error);
      alert('製令列印失敗，請稍後再試！');
    }
  });
};


  return (
    <>
      {/* 全域 Busy 遮罩 */}
      <Backdrop sx={{ color: '#fff', zIndex: (t) => t.zIndex.drawer + 1 }} open={busy}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Box sx={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
        <Box sx={{ width: 300 }}>
          <FormControl fullWidth disabled={busy}>
            <FormLabel id="demo-row-radio-buttons-group-label">條件</FormLabel>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              value={request.isHand}
              onChange={(e) => handleInputChange(e, 'isHand')}
            >
              <FormControlLabel value={1} control={<Radio />} label="手動" />
              <FormControlLabel value={0} control={<Radio />} label="台日HTC" />
            </RadioGroup>
          </FormControl>
        </Box>

        <Box sx={{ width: 300 }}>
          <FormControl style={{ width: '100px' }} disabled={busy}>
            <InputLabel id="demo-simple-select-label">批號</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={request.way}
              label="批號"
              onChange={(e) => handleInputChange(e, 'way')}
            >
              <MenuItem value="piNum">批號</MenuItem>
              <MenuItem value="orderNum">訂單號碼</MenuItem>
            </Select>
          </FormControl>
          <TextField
            label="號碼"
            variant="outlined"
            value={request.num}
            onChange={(e) => handleInputChange(e, 'num')}
            disabled={busy}
          />
        </Box>

        <Box sx={{ width: 300 }}>
          <TextField
            label="機種"
            variant="outlined"
            value={request.model}
            onChange={(e) => handleInputChange(e, 'model')}
            disabled={busy}
          />
          <TextField
            label="台數QTY"
            variant="outlined"
            value={request.qty}
            onChange={(e) => handleInputChange(e, 'qty')}
            disabled={busy}
          />
        </Box>

        <Box sx={{ width: 300 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={['DatePicker']}>
              <DatePicker
                label="需求日"
                value={value}
                onChange={(newValue) => setValue(newValue)}
                disabled={busy}
              />
            </DemoContainer>
          </LocalizationProvider>
        </Box>
      </Box>

      <Box sx={{ height: 400, width: '100%' }}>
        <Button variant="text" onClick={handleStep1Submit} disabled={busy}>
          搜尋 {isBusy('step1') && <CircularProgress size={16} sx={{ ml: 1 }} />}
        </Button>
        <Button variant="text" onClick={handleStep2Submit} disabled={busy}>
          開始發動 {isBusy('step2') && <CircularProgress size={16} sx={{ ml: 1 }} />}
        </Button>
        <Button variant="text" onClick={() => { if (!busy) { setRow1([]); setRow2([]); setBillNums([]); setCmdNoStart(''); setCmdNoEnd('');} }} disabled={busy}>
          清除Clear
        </Button>

        <DataGrid
          rows={row1}
          columns={columns}
          isCellEditable={(params) => !busy && !!params.colDef.editable}   // 忙碌時禁編
          processRowUpdate={(newRow, oldRow) => {
            if (busy) return oldRow;
            const 本次發動數 = Number(newRow.本次發動數 ?? 0);
            const 未發動數量 = Number(oldRow.訂單數量 ?? 0) - Number(oldRow.發動數量 ?? 0);
            if (本次發動數 < 0) {
              alert('本次發動數不能小於 0');
              throw new Error('Invalid input: 小於 0');
            }
            if (本次發動數 > 未發動數量) {
              alert(`本次發動數不能大於未發動數量 (${未發動數量})`);
              throw new Error('Invalid input: 超過未發動數量');
            }
            const updatedRows = row1.map((row) => (row.id === newRow.id ? { ...row, ...newRow } : row));
            setRow1(updatedRows);
            return newRow;
          }}
          onProcessRowUpdateError={(error) => console.error('Row update error:', error)}
          initialState={{ pagination: { paginationModel: { pageSize: 20 } } }}
          rowHeight={38}
          headerHeight={32}
          pageSizeOptions={[20]}
          disableRowSelectionOnClick
        />
      </Box>

      <Box sx={{ height: 400, width: '100%' }}>
        <Typography variant="h6" gutterBottom>產生採購單</Typography>
        <Button variant="text" onClick={handleStep3Submit} disabled={busy}>
          1.產生資料 {isBusy('step3') && <CircularProgress size={16} sx={{ ml: 1 }} />}
        </Button>
        <Button variant="text" onClick={handleClickOpen} disabled={busy}>2.存入資料</Button>
        <Button variant="text" onClick={downloadExcel} disabled={busy}>
          3.BOM用料表 {isBusy('bom') && <CircularProgress size={16} sx={{ ml: 1 }} />}
        </Button>
        <Button variant="text" onClick={downloadMakeCmdExcel} disabled={busy}>
          4.印製令Print {isBusy('print') && <CircularProgress size={16} sx={{ ml: 1 }} />}
        </Button>

        <Typography variant="h6" gutterBottom>生產製令</Typography>

        <Typography variant="h6" gutterBottom>
          製令區間：
          <span style={{ marginLeft: 8 }}>
            {cmdNoStart && cmdNoEnd ? `${cmdNoStart} ~ ${cmdNoEnd}` : '（尚未產生）'}
          </span>
        </Typography>
        <Typography variant="h6" gutterBottom>有無製程{hasMakeProcess ? ':有' : ':無'}</Typography>

        <DataGrid
          rows={row2}
          columns={columns2}
          initialState={{ pagination: { paginationModel: { pageSize: 5 } } }}
          rowHeight={38}
          headerHeight={32}
          pageSizeOptions={[5]}
          disableRowSelectionOnClick
        />
      </Box>

      <Dialog open={open} keepMounted onClose={busy ? undefined : handleClose} aria-describedby="alert-dialog-slide-description">
        <DialogTitle>確定要存入資料?</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">確認好再操作</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} disabled={busy}>No</Button>
          <Button onClick={handleStep4Submit} disabled={busy}>
            OK {isBusy('step4') && <CircularProgress size={16} sx={{ ml: 1 }} />}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

// ------------------- PDF 樣式與文件（保留原本） -------------------
Font.register({ family: 'TaipeiSansTCBeta-Bold', src: 'path/to/TaipeiSansTCBeta-Bold.ttf' });
Font.register({ family: 'TaipeiSansTCBeta-Light', src: 'path/to/TaipeiSansTCBeta-Light.ttf' });

const pageWidth = (24.1 * 72) / 2.54;
const pageHeight = (14 * 72) / 2.54;
const cellWidth = pageWidth / 6;

const styles = StyleSheet.create({
  page: { flexDirection: 'column', backgroundColor: 'white', padding: 24, width: pageWidth, height: pageHeight },
  onePage: { flexDirection: 'row', backgroundColor: 'white', padding: 24, width: pageWidth, height: pageHeight },
  title: { fontSize: 20, textAlign: 'center', fontFamily: 'TaipeiSansTCBeta-Bold', marginBottom: 10 },
  smallTitle: { fontSize: 12, textAlign: 'flex-start', fontFamily: 'TaipeiSansTCBeta-Light', marginBottom: 20 },
  tableContainer: { flexDirection: 'row' },
  tableHeader: { backgroundColor: '#eee' },
  tableRow: { flexDirection: 'row', alignItems: 'center', height: 24 },
  tableHeaderCell: { fontSize: 12, width: cellWidth, fontFamily: 'TaipeiSansTCBeta-Light', textAlign: 'center' },
  tableCell: { fontSize: 10, width: cellWidth, fontFamily: 'TaipeiSansTCBeta-Light', textAlign: 'center' },
  dayCell: { fontSize: 16, textAlign: 'flex-start', fontFamily: 'TaipeiSansTCBeta-Light', marginRight: 100 },
});

const MyDocument = ({ data, day }) => (
  <Document>
    {data.map((bigitem, index) => (
      <Page key={index} size={{ width: pageWidth, height: pageHeight }} style={styles.page}>
        <View style={{ height: 32 }} />
        <View style={styles.tableContainer}>
          <Text style={styles.tableHeaderCell}>製令No#</Text>
          <Text style={styles.tableHeaderCell}>{bigitem.單號}</Text>
          <Text style={styles.tableHeaderCell} />
          <Text style={styles.tableHeaderCell} />
          <Text style={styles.tableHeaderCell} />
          <Text style={styles.tableHeaderCell} />
          <Text style={styles.tableHeaderCell}>{day}</Text>
          <Text style={styles.tableHeaderCell} />
        </View>
        <View style={{ height: 12 }} />
        <View style={styles.tableContainer}>
          <Text style={styles.tableHeaderCell} />
          <Text style={styles.tableHeaderCell}>{bigitem.批號}</Text>
          <Text style={styles.tableHeaderCell} />
          <Text style={styles.tableHeaderCell} />
          <Text style={styles.tableHeaderCell} />
          <Text style={styles.tableHeaderCell} />
          <Text style={styles.tableHeaderCell}>{bigitem.日期}</Text>
          <Text style={styles.tableHeaderCell} />
        </View>
        <View style={styles.tableContainer}>
          <Text style={styles.tableHeaderCell} />
          <Text style={styles.tableHeaderCell}>{bigitem.圖號}</Text>
          <Text style={styles.tableHeaderCell} />
          <Text style={[styles.tableHeaderCell, { fontSize: 8, flexShrink: 1 }]} numberOfLines={1} ellipsizeMode="clip">
            {bigitem.規格}
          </Text>
          <Text style={styles.tableHeaderCell} />
          <Text style={styles.tableHeaderCell} />
          <Text style={styles.tableHeaderCell}>{bigitem.生產量}</Text>
          <Text style={styles.tableHeaderCell} />
        </View>
        <View style={styles.tableContainer}>
          <Text style={styles.tableHeaderCell} />
          <Text style={styles.tableHeaderCell}>{bigitem.物品名}</Text>
          <Text style={styles.tableHeaderCell} />
          <Text style={styles.tableHeaderCell}>{bigitem.素材}</Text>
          <Text style={styles.tableHeaderCell} />
          <Text style={styles.tableHeaderCell} />
          <Text style={styles.tableHeaderCell} />
          <Text style={styles.tableHeaderCell} />
        </View>
        <View style={styles.tableContainer}>
          <Text style={styles.tableHeaderCell} />
          <Text style={styles.tableHeaderCell} />
          <Text style={styles.tableHeaderCell} />
          <Text style={styles.tableHeaderCell} />
          <Text style={styles.tableHeaderCell} />
          <Text style={styles.tableHeaderCell} />
          <Text style={styles.tableHeaderCell} />
          <Text style={styles.tableHeaderCell} />
        </View>

        {(bigitem.工程內容們 || []).map((item, index1) => (
          <React.Fragment key={index1}>
            <View style={{ height: 2 }} />
            <View style={styles.tableContainer}>
              <Text style={styles.tableHeaderCell} />
              <Text style={styles.tableHeaderCell}>{item}</Text>
              <Text style={styles.tableHeaderCell} />
              <Text style={styles.tableHeaderCell} />
              <Text style={styles.tableHeaderCell} />
              {(bigitem.工作職場們 || []).map((w, index2) => (index1 === index2 ? <Text key={index2} style={styles.tableHeaderCell}>{w}</Text> : null))}
            </View>
          </React.Fragment>
        ))}

        <View style={{ position: 'absolute', right: -32, bottom: 24 }}>
          <Text style={[styles.dayCell, { fontSize: 8 }]}>{`Admin ${day}`}</Text>
        </View>
      </Page>
    ))}
  </Document>
);
